import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_ARTIST_SETS_LIST = gql`
  query getArtistSetsList($search: String, $limit: Int, $offset: Int, $sortField: String, $sortOrder: Int) {
    getArtistSetsList(search: $search, limit: $limit, offset: $offset, sortField: $sortField, sortOrder: $sortOrder) {
      total
      isAuth
      artistSlugNames
      venueSlugNames
      artistSets {
        _id
        artistName
        artistSetName
        artistSetReadableName {
          en
          es
          ca
          pt
        }
        artistSlugName
        artistSetSlugName
        artistSetGenres
        artistReadableName {
          en
          es
          ca
          pt
        }
        countryCode
        createdAt
        dateTimeEndReal
        dateTimeStartReal
        dateTimeStartHuman
        artistSetGenres
        duration
        image {
          en
          es
          ca
          pt
        }
        updatedAt
        mediaLinks {
          itunes
          video
          web
          disco
        }
        postUri
        shortTitle {
          en
          es
          ca
          pt
        }
        show
        showDate
        showDateTime
        showTicket
        showVenue
        smallText {
          en
          es
          ca
          pt
        }
        venueSlugName
        stock
        timezone
      }
    }
  }
`;

const getArtistSetsList = async (search = '', { limit, offset, sortField, sortOrder } = {}) => {
  try {
    const result = await client
      .query({
        query: GET_ARTIST_SETS_LIST,
        errorPolicy: 'all',
        fetchResults: true,
        fetchPolicy: 'no-cache',
        variables: { search, limit, offset, sortField, sortOrder },
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { getArtistSetsList: artistSetsListData },
    } = result;

    if (artistSetsListData) {
      return artistSetsListData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getArtistSetsList = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getArtistSetsList Error: ${error}`);
    return null;
  }
};

export default getArtistSetsList;
